import { render, staticRenderFns } from "./VDropdownItem.vue?vue&type=template&id=4d5257a6&scoped=true&"
import script from "./VDropdownItem.vue?vue&type=script&lang=js&"
export * from "./VDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5257a6",
  null
  
)

export default component.exports